import ChatContent from './chat/ChatContent';
import AuthChatInput from '../../components/shared/chat-input/AuthChatInput';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

const AiAuthContainer = () => {
	const { pathname } = useLocation();
	const type = pathname.includes('/sign-up') ? 'sign-up' : 'sign-in';
	const {authMessages} = useSelector(
		(state: RootState) => state.chats
	);
	return (
		<div className='mt-auto flex justify-center max-w-full w-full'>
			<div className='my-2 flex flex-col  w-[80%]'>
				<div className='w-full bg-primary-default py-2 px-5 flex flex-wrap items-center text-white text-[15px]'>
					<img alt='avatar' className='mr-4' src='/svg/auth/avatar.svg' />
					Rebecca @Orient Express La Dolce Vita
				</div>
				<ChatContent type={type} />
				<div className='p-5 border border-gray-100'>
					{!!authMessages.length && <AuthChatInput type={type} />}
				</div>
			</div>
		</div>
	)
}

export default AiAuthContainer;